import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.announcements)

export const ANNOUNCEMENTS_INSTANCE = service.instanceKey

export const ANNOUNCEMENTS_ENDPOINTS = {
  SELECT: "/admin/announcements/select",
  REMOVE: "/admin/announcements/remove",
  SAVE: "/admin/announcements/save",
  ADD: "/admin/announcements/add",
  ADD_GROUP: "/admin/announcements/add_group",
  SELECT_GROUPS: "/admin/announcements/selectgroups",
  UPDATE_GROUP_NAME: "/admin/announcements/update_group_name",
  UPDATE_GROUP_MEMBERS: "/admin/announcements/update_group_members",
  DELETE_GROUP: "/admin/announcements/delete_group",
  CHECK_GROUP: "/admin/announcements/check_group",
  VIEW_GROUPS: "/admin/announcements/view/groups",
  VIEW_DETAIL: "/admin/announcements/view/detail",
  READ: "/admin/announcements/read",
  FINISH: "/admin/announcements/finish",
} as const

export const announcementsService = {
  instanceKey: service.instanceKey,

  select: (params?: Record<string, any>) =>
    service.get(ANNOUNCEMENTS_ENDPOINTS.SELECT, params),
  remove: (id: string | number, comment: string) =>
    service.post(
      `${ANNOUNCEMENTS_ENDPOINTS.REMOVE}?id=${id}&comment=${encodeURIComponent(
        comment
      )}`
    ),
  save: (body: Record<string, any>) =>
    service.post(ANNOUNCEMENTS_ENDPOINTS.SAVE, body),
  add: (body: Record<string, any>) =>
    service.post(ANNOUNCEMENTS_ENDPOINTS.ADD, body),
  addGroup: (body: Record<string, any>) =>
    service.post(ANNOUNCEMENTS_ENDPOINTS.ADD_GROUP, body),
  selectGroups: () => service.get(ANNOUNCEMENTS_ENDPOINTS.SELECT_GROUPS),
  updateGroupName: (
    id: string | number,
    description: string,
    body: Record<string, any>
  ) =>
    service.post(
      `${ANNOUNCEMENTS_ENDPOINTS.UPDATE_GROUP_NAME}?id=${id}&description=${description}`,
      body
    ),
  updateGroupMembers: (id: string | number, body: Record<string, any>) =>
    service.post(
      `${ANNOUNCEMENTS_ENDPOINTS.UPDATE_GROUP_MEMBERS}?id=${id}`,
      body
    ),
  deleteGroup: (id: string | number) =>
    service.post(`${ANNOUNCEMENTS_ENDPOINTS.DELETE_GROUP}?id=${id}`),
  checkGroup: (description: string, id: string | number = -1) =>
    service.get(ANNOUNCEMENTS_ENDPOINTS.CHECK_GROUP, { description, id }),
  viewGroups: (id: string | number) =>
    service.get(`${ANNOUNCEMENTS_ENDPOINTS.VIEW_GROUPS}?id=${id}`),
  viewDetail: (id: string | number) =>
    service.get(`${ANNOUNCEMENTS_ENDPOINTS.VIEW_DETAIL}?id=${id}`),
  markRead: (id: string | number) =>
    service.post(`${ANNOUNCEMENTS_ENDPOINTS.READ}?id=${id}`),
  finish: (id: string | number, body: Record<string, any>) =>
    service.post(`${ANNOUNCEMENTS_ENDPOINTS.FINISH}?id=${id}`, body),
}
